<em-main>
  @if (proposalPageObject$ | async; as proposalPageObject) {
    <div class="layout--column layout--gap-larger">
      <em-client-section
        (propsChange)="createOrUpdateProposal($event)"
        [props]="proposalPageObject.client"
        [creationMode]="!proposalId"
        [completed]="proposalPageObject.sectionCompleted.client"></em-client-section>
      @if (proposalPageObject.sectionCompleted.client) {
        <em-fna-section
          (propsChange)="update($event, 'fna')"
          (policyNumberChanged)="setCurrentProtectionSearchResult($event)"
          [props]="proposalPageObject.fna"
          [completed]="proposalPageObject.sectionCompleted.fna">
        </em-fna-section>
      }
      @if (
        proposalPageObject.sectionCompleted.client &&
        proposalPageObject.healthQuestionnaire &&
        proposalPageObject.healthAnswers
      ) {
        <em-health-questionnaire-section
          (propsChange)="update($event, 'healthAnswers')"
          [props]="{
            healthQuestionnaire: proposalPageObject.healthQuestionnaire,
            healthAnswers: proposalPageObject.healthAnswers,
          }"
          [completed]="
            proposalPageObject.sectionCompleted.healthQuestionnaire
          "></em-health-questionnaire-section>
      }
      @if (
        proposalPageObject.sectionCompleted.healthQuestionnaire &&
        !isEligible(proposalPageObject.healthQuestionnaire?.categoryCode)
      ) {
        <p-card class="p-card__error">
          <h3 i18n>Non éligible</h3>
          <p i18n>Le client n'est pas éligible au produit Emma.</p>
        </p-card>
      }
      @if (
        proposalPageObject.sectionCompleted.healthQuestionnaire &&
        isEligible(proposalPageObject.healthQuestionnaire?.categoryCode) &&
        proposalPageObject.sectionCompleted.fna
      ) {
        <em-extra-questionnaires-section
          (propsChange)="update($event, 'healthAnswers')"
          [props]="proposalPageObject.extraQuestionnaires"
          [completed]="
            proposalPageObject.sectionCompleted.extraQuestionnaires
          "></em-extra-questionnaires-section>

        <em-note-section
          (propsChange)="update($event, 'note')"
          [props]="proposalPageObject.note"
          [completed]="true"></em-note-section>

        @if (
          !isNewCoverageBuilderEnabled &&
          proposalPageObject.protection &&
          proposalPageObject.fna &&
          proposalPageObject.fna.needs &&
          proposalPageObject.age &&
          proposalPageObject.healthAnswers &&
          proposalPageObject.healthAnswers.smoker !== undefined &&
          proposalPageObject.healthAnswers.sex &&
          proposalPageObject.ratesVersion
        ) {
          <em-coverage-builder-section
            [ratesVersion]="proposalPageObject.ratesVersion"
            [jobRiskClass]="proposalPageObject.jobRiskClass"
            [willRequireExtraRequirements]="proposalPageObject.willRequireExtraRequirements"
            [age]="proposalPageObject.age"
            [smoker]="proposalPageObject.healthAnswers.smoker"
            [sex]="proposalPageObject.healthAnswers.sex"
            [selectedProtection]="proposalPageObject.protection"
            [needs]="proposalPageObject.fna.needs"
            [completed]="proposalPageObject.sectionCompleted.protectionBuilder"></em-coverage-builder-section>
        }
        @if (
          isNewCoverageBuilderEnabled &&
          proposalPageObject.protection &&
          proposalPageObject.fna &&
          proposalPageObject.fna.needs &&
          proposalPageObject.age &&
          proposalPageObject.healthAnswers &&
          proposalPageObject.healthAnswers.smoker !== undefined &&
          proposalPageObject.healthAnswers.sex &&
          proposalPageObject.ratesVersion &&
          proposalPageObject.healthQuestionnaire &&
          proposalPageObject.healthQuestionnaire.categoryCode &&
          proposalPageObject.client
        ) {
          <em-protection-builder-section
            [fullName]="clientFullName(proposalPageObject.client)"
            [prefilledProtection]="proposalPageObject.protection"
            [ratesVersion]="proposalPageObject.ratesVersion"
            [age]="proposalPageObject.age"
            [sex]="proposalPageObject.healthAnswers.sex"
            [smoker]="proposalPageObject.healthAnswers.smoker"
            [categoryCode]="proposalPageObject.healthQuestionnaire.categoryCode"
            [jobRiskClass]="proposalPageObject.jobRiskClass"
            [needs]="proposalPageObject.fna.needs"
            [completed]="proposalPageObject.sectionCompleted.protectionBuilder"
            [willRequireExtraRequirements]="proposalPageObject.willRequireExtraRequirements"
            (protectionReset)="displayProtectionResetToaster()"></em-protection-builder-section>
        }
        @if (proposalPageObject.sectionCompleted.protectionBuilder) {
          <em-beneficiaries-section
            (propsChange)="update($event, 'beneficiaries')"
            [props]="proposalPageObject.beneficiaries"
            [province]="proposalPageObject.client!.province!"
            [totalCoverage]="totalCoverage(proposalPageObject.protection?.personInsurances)"
            [completed]="proposalPageObject.sectionCompleted.beneficiaries"></em-beneficiaries-section>
        }
        @if (proposalPageObject.sectionCompleted.protectionBuilder) {
          <em-replacement-notice-section
            (propsChange)="update($event, 'replacementNotice')"
            [props]="proposalPageObject.replacementNotice?.hasPolicyReplacementNotice"
            [completed]="
              proposalPageObject.sectionCompleted.replacementNotice
            "></em-replacement-notice-section>
        }
        @if (proposalPageObject.sectionCompleted.protectionBuilder) {
          <em-address-section
            (propsChange)="update($event, 'address')"
            [props]="proposalPageObject.address"
            [completed]="proposalPageObject.sectionCompleted.address"></em-address-section>
        }
        @if (proposalPageObject.sectionCompleted.protectionBuilder) {
          <em-id-document-section
            (propsChange)="update($event, 'idDocument')"
            [props]="proposalPageObject.idDocument"
            [completed]="proposalPageObject.sectionCompleted.idDocument">
          </em-id-document-section>
        }
        @if (
          proposalPageObject.sectionCompleted.idDocument &&
          proposalPageObject.sectionCompleted.protectionBuilder
        ) {
          <em-disclosures-section
            (propsChange)="update($event, 'disclosures')"
            [props]="proposalPageObject.disclosures"
            [primaryAgentFullName]="proposalPageObject.primaryAgentFullName!"
            [clientFullName]="clientFullName(proposalPageObject.client!)"
            [idDocument]="proposalPageObject.idDocument!"
            [completed]="proposalPageObject.sectionCompleted.disclosures">
          </em-disclosures-section>
        }
      }
      @if (isSendToBrokerageEnabled && proposalId) {
        <div class="layout--row layout--space-between">
          <div class="layout--row gap-3">
            <p-button
              [disabled]="!!proposalPageObject.isSent"
              class="emma-pro-delete-btn"
              i18n-label
              label="Supprimer la proposition"
              icon="pi pi-trash"
              (onClick)="delete()"></p-button>
            <p-button
              [loading]="isCopyToBrokerageButtonLoading"
              class="emma-pro-white-btn"
              i18n-label
              label="Copier en courtage"
              icon="pi pi-copy"
              (onClick)="copyToBrokerage()"></p-button>
          </div>
          <div>
            <p-button
              [loading]="isSendButtonLoading"
              i18n-label
              label="Envoyer la proposition"
              icon="pi pi-send"
              [disabled]="!isComplete(proposalPageObject.sectionCompleted)"
              (onClick)="send()"></p-button>
          </div>
        </div>
      }
      @if (!isSendToBrokerageEnabled && proposalId) {
        <div class="layout--row layout--space-between">
          <p-button
            [disabled]="!!proposalPageObject.isSent"
            class="emma-pro-delete-btn"
            i18n-label
            label="Supprimer la proposition"
            icon="pi pi-trash"
            (onClick)="delete()"></p-button>
          <div>
            <p-button
              [loading]="isSendButtonLoading"
              i18n-label
              label="Envoyer la proposition"
              icon="pi pi-send"
              [disabled]="!isComplete(proposalPageObject.sectionCompleted)"
              (onClick)="send()"></p-button>
          </div>
        </div>
      }
    </div>
  } @else {
    <em-skeleton></em-skeleton>
  }
</em-main>
<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
